import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
// @ts-ignore next
import { LogoHeader, ApplicationThemeProvider } from '@adc/ui-adc';
import { getWebComponentName } from '../utils';
const WrappedComponent = ({ theme, ...props }) => {
    return (React.createElement(ApplicationThemeProvider, { theme: theme },
        React.createElement(LogoHeader, { ...props })));
};
const WebComponent = r2wc(WrappedComponent, {
    props: {
        theme: 'json',
    },
});
customElements.define(getWebComponentName('logo-header'), WebComponent);
